import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "../../store";

export interface DrawerState {
  open?: boolean | undefined;
  formType?: string | undefined;
  isCreate?: boolean;
}

export const selectDrawer = createSelector(
  (state: RootState) => state,
  (state) => state.drawer,
);

export const selectDrawerDisplay = createSelector(
  (state: RootState) => state.drawer,
  (drawer) => ({
    open: drawer.open,
    formType: drawer.formType,
    isCreate: drawer.isCreate,
  }),
);

export const selectDrawerIsCreate = createSelector(
  (state: RootState) => state.drawer.isCreate,
  (isCreate) => isCreate,
);

export const selectDrawerOpen = createSelector(
  (state: RootState) => state.drawer.open,
  (open) => open,
);

export const drawerSlice = createSlice({
  name: "drawer",
  initialState: { open: false } as DrawerState,
  reducers: {
    updateDrawerOpen: (state, action: PayloadAction<DrawerState>) => {
      state.open = action.payload.open;
      state.formType = action.payload.formType;
      state.isCreate = action.payload.isCreate || false;
    },
  },
});

export const { updateDrawerOpen } = drawerSlice.actions;
